const o=["country","region","postcode","district","place","locality","neighborhood","street","address"];export{o as MapSearchCoordinateTypes};